import linkUrlConfig from './../../../../configs/LinkUrlConfig';

export default {
  BULLISH: 'BULLISH',
  BEARISH: 'BEARISH',
  NEUTRAL: 'NEUTRAL',
  STRONG_BULLISH: 'STRONG_BULLISH',
  STRONG_BEARISH: 'STRONG_BEARISH',
  idIndicators: 'id',
  MOVING_AVERAGE: 'MovingAvg',
  INDICATORS: 'Indicators',
  SUMMARY: 'Summary',
  code: 'code',

  listColumnTableVisibility: {
    TICKER: 'organCode',
    TYPE: 'type',
    _15MINUTES: '_15MINUTES',
    HOURLY: 'hourly',
    DAILY: 'daily',
    WEEKLY: 'weekly',
  },

  listColumnTable: {
    TICKER: 'organCode',
    MATCH_PRICE: 'matchPrice',
    _15MINUTES_MA5: 'quarterly.ma5',
    _15MINUTES_RSI: 'quarterly.rsi',
    _15MINUTES_OLD_RSI: 'quarterly.rsiPrev',
    _15MINUTES_CMF: 'quarterly.cmf',
    _15MINUTES_ROC: 'quarterly.roc',
    _15MINUTES_OLD_ROC: 'quarterly.rocPrev',

    HOURLY_MA5: 'hourly.ma5',
    HOURLY_RSI: 'hourly.rsi',
    HOURLY_OLD_RSI: 'hourly.rsiPrev',
    HOURLY_CMF: 'hourly.cmf',
    HOURLY_ROC: 'hourly.roc',
    HOURLY_OLD_ROC: 'hourly.rocPrev',

    DAILY_MA5: 'daily.ma5',
    DAILY_RSI: 'daily.rsi',
    DAILY_OLD_RSI: 'daily.rsiPrev',
    DAILY_CMF: 'daily.cmf',
    DAILY_ROC: 'daily.roc',
    DAILY_OLD_ROC: 'daily.rocPrev',

    WEEKLY_MA5: 'weekly.ma5',
    WEEKLY_RSI: 'weekly.rsi',
    WEEKLY_OLD_RSI: 'weekly.rsiPrev',
    WEEKLY_CMF: 'weekly.cmf',
    WEEKLY_ROC: 'weekly.roc',
    WEEKLY_OLD_ROC: 'weekly.rocPrev',
  },
  listTicker: {
    ORGAN_CODE: 'organCode',
    TICKER: 'ticker',
    ORGAN_SHORT_NAME: 'organShortName',
    COM_GROUP_CODE: 'comGroupCode',
  },
  listIndex: {
    COM_GROUP_CODE: 'comGroupCode',
    COM_GROUP_NAME: 'comGroupName',
  },
  defaultCode: 'VNINDEX',
  indexData: {
    VALUE: 'matchPrice',
    VALUE_CHANGE: 'priceChange',
    PERCENT_VALUE_CHANGE: 'percentPriceChange',
  },
  linkPDF: linkUrlConfig.ta_signal_link_pdf,
};
